import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import './BuscarDelivery.css';
import { Button, message, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BuscarDelivery = ({ onItemPress, closeModal, setPagamentoConcluido, setPagamentos, setAcresDescFrete, acresDescFrete, setTravarAcrescimoDescFrete, setDocumentoCupom, setNomeCupom, consumidorIntegrado, setConsumidorIntegrada, consumidor,
  setConsumidor, setTokenPedidoTechsapp }) => {
  // validarEstoque da prop é para telas que não necessite de validação usarem como false

  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [restauranteId, setRestauranteId] = useState('');
  // currentPage representa a próxima página a ser carregada
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loja, setLoja] = useState({});
  const [isCnpj, setIsCnpj] = useState(false);
  // Refs para o container de scroll e para o elemento trigger
  const containerRef = useRef(null);
  const targetRef = useRef(null);

  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      axios
        .get(`https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`, options)
        .then(response => {
          setRestauranteId(response.data.id);
          setLoja(response.data);
          console.log(response.data);
        })
        .catch(error => console.error('Erro ao buscar restaurante:', error));
    }
  }, [idUser, accessToken]);


  function calcularAcrescimoPorProduto(valorTotalAcrescimo, numeroProdutos) {
    const acrescimoUnitario = valorTotalAcrescimo / numeroProdutos;

    const valores = Array.from({ length: numeroProdutos }, () =>
      parseFloat(acrescimoUnitario.toFixed(2))
    );

    // Ajuste final de centavos
    const somaAtual = valores.reduce((acc, val) => acc + val, 0);
    const diferenca = parseFloat((valorTotalAcrescimo - somaAtual).toFixed(2));

    if (diferenca !== 0) {
      valores[0] += diferenca;
    }

    return valores;
  }
  function validarDocumento(documento) {
    // Remover caracteres não numéricos
    documento = documento.replace(/[^\d]+/g, '');

    // Verificar se o documento é um CPF
    if (documento.length === 11) {
      let cpf = documento;
      let add = 0;
      for (let i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(9))) return false;

      add = 0;
      for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(10))) return false;

      return true;
    }

    // Verificar se o documento é um CNPJ
    else if (documento.length === 14) {
      let cnpj = documento;
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(0))) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(1))) return false;

      return true;
    }

    // Se não for nem CPF nem CNPJ, retorna false
    else {
      return false;
    }
  }
  const buscarConsumidor = async (cpfCnpj) => {
    if (validarDocumento(cpfCnpj)) {
      const numericText = cpfCnpj.replace(/\D/g, '');
      setIsCnpj(numericText.length > 11);
      if (accessToken) {
        setIsLoading(true);
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        axios
          .get(
            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${restauranteId}/cpfcnpj/${cpfCnpj}`,
            options,
          )
          .then(consumidorResp => {
            if (consumidorResp) {
              if (consumidorResp.data) {
                setConsumidor(consumidorResp.data);
                setIsLoading(false);
              } else {
                setIsLoading(false);
                setConsumidor(true);
              }
            } else {
              setIsLoading(false);
              setConsumidor(true);
            }
          }).catch(error => {
            console.error('Erro ao buscar consumidor:', error);
            setConsumidor(true);
          })
      }
    }
  };

  const handleItemPress = async (item) => {
    const pedidoDecoded = JSON.parse(atob(item.pedido));
    const produtos = pedidoDecoded.produtos;
    const cpfPedido = pedidoDecoded.cpf;
    setTokenPedidoTechsapp(pedidoDecoded.token);
    if (cpfPedido) {
      setDocumentoCupom(cpfPedido);
      await buscarConsumidor(cpfPedido);


      // setConsumidorIntegrada(respConsumidor);
    }

    const nomePedido = pedidoDecoded.nome;
    if (nomePedido) {
      setNomeCupom(nomePedido);
    }
    const valorFreteTotal = pedidoDecoded.frete;
    const valorAcrescimoCalculado = pedidoDecoded.total - pedidoDecoded.frete - pedidoDecoded.subtotal;
    console.log('Acrécimos = ' + valorAcrescimoCalculado);
    const arrayTeste = [];

    // 1. Calcular total de unidades
    const totalUnidades = produtos.reduce((acc, p) => acc + p.quantidade, 0);

    // 2. Calcular valor de frete por unidade
    const fretePorUnidade = valorFreteTotal / totalUnidades;

    // 3. Calcular frete proporcional por produto
    const fretesCalculados = produtos.map((p) =>
      parseFloat((fretePorUnidade * p.quantidade).toFixed(2))
    );

    // 4. Ajustar diferença de centavos no primeiro item (garantir soma == valorFreteTotal)
    const somaFrete = fretesCalculados.reduce((acc, val) => acc + val, 0);
    const diferenca = parseFloat((valorFreteTotal - somaFrete).toFixed(2));
    if (diferenca !== 0) {
      fretesCalculados[0] += diferenca;
    }
    const acrescimosCalculados = calcularAcrescimoPorProduto(valorAcrescimoCalculado, produtos.length);
    // 5. Buscar dados dos produtos e montar lista final
    for (let i = 0; i < produtos.length; i++) {
      const element3 = produtos[i];
      try {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        };

        const produtoTechFood = await axios.get(
          `https://techfood-api.herokuapp.com/v1/restaurantes/${restauranteId}/produtos/buscarporcodigointegracao/${element3.codigoIntegracao}`,
          options
        );
        console.log(produtoTechFood.status);



        let produtoAux = produtoTechFood.data;
        produtoAux.quantidade = element3.quantidade;
        produtoAux.acrescimo = 0;
        produtoAux.desconto = 0;
        produtoAux.valorAcrescimo = 0;
        produtoAux.valorDesconto = 0;
        produtoAux.frete = fretesCalculados[i]; // valor proporcional ao total
        produtoAux.preco = element3.valor / element3.quantidade;
        produtoAux.travado = true;
        if (acrescimosCalculados.length > 0) {
          produtoAux.acrescimo = acrescimosCalculados[i];
          produtoAux.valorAcrescimo = acrescimosCalculados[i];
        }

        arrayTeste.push(produtoAux);
        let acresDescFreteAux = acresDescFrete;
        acresDescFreteAux.frete = valorFreteTotal;
        setTravarAcrescimoDescFrete(true);
        setAcresDescFrete(acresDescFreteAux);
      } catch (error) {


        if (error.status == 404) {
          console.log('produto não encontrado');
          onItemPress([]);
          setTokenPedidoTechsapp(null);
          closeModal();
          setPagamentoConcluido(false);
          message.info('Pedido com produto não integrado!!');
          return;
        } else {
          console.error('Erro ao buscar produto:', element3.codigoIntegracao, error);
        }
      }
    }

    onItemPress(arrayTeste);
    console.log(arrayTeste);
    closeModal();
    setPagamentoConcluido(false);
    setPagamentos([]);
  };


  const [emissor, setEmissor] = useState();

  useEffect(() => {
    if (loja) {
      let cnpjAux = loja?.cnpj?.replaceAll('.', '');
      cnpjAux = cnpjAux?.replaceAll('/', '');
      cnpjAux = cnpjAux?.replaceAll('-', '');

      if (cnpjAux) {

        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        axios
          .get(
            `https://technfe-api.herokuapp.com/v1/emissor/cnpj/${cnpjAux}`,
            options,
          ).then((resp) => setEmissor(resp.data));
      }
    }
  }, [loja]);

  useEffect(() => {
    const fetchData = async () => {


      setIsLoading(true);
      try {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Basic ${loja.basic_token}`,
          },
        };

        const response = await axios.get(
          `https://www.${loja.dominio}.com.br/backend/api/pdv/pedido/getByStatusCompleto2/${emissor?.status_emissao}`,
          options
        );
        console.log(response);

        setProducts(response.data);

      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      } finally {
        setIsLoading(false);
      }

    }
    console.log(emissor);
    if (loja.dominio && emissor) {
      fetchData();
    }


  }, [loja, emissor]);


  const renderItem = (item) => {
    return (
      <div
        className="card"
        onClick={() => {
          handleItemPress(item)
        }}
        style={{ position: 'relative' }}
      >
        <span className="card-text" >{item.token}</span>
        <br />
        <span className="card-text" >{JSON.parse(atob(item.pedido)).nome}</span>  <br />
        <span className="card-text">
          {new Date(item.data).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          })}
        </span><br />
        <span className="card-text">
          {Number(item.total_pedido).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}
        </span>
        <br />
        <span className="card-text" >TechsApp</span>
      </div>
    );
  };


  return (
    <div className="container-buscar">
      <div className="modal-header">
        <Button
          type="primary"
          onClick={closeModal}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Voltar</span>
        </Button>
        <h2>Buscar Delivery</h2>
      </div>
      {isLoading && products.length === 0 ? (

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
          <Spin
            spinning={isLoading}
            tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
            size="large"
          />
        </div>




      ) : (
        <div className="scroll-container" ref={containerRef}>
          <div className="product-list">
            {products.length > 0 ? (
              products.map(product => (
                JSON.parse(atob(product.pedido)).nome ?
                  <React.Fragment key={product.id}>{renderItem(product)}</React.Fragment> : ''
              ))
            ) : (
              <p className="empty-list-text">Nenhum produto encontrado</p>
            )}
          </div>
          {isLoading && <div className="loading">Carregando...</div>}
          {/* Elemento trigger para o Intersection Observer */}
          <div ref={targetRef} id="scroll-end" style={{ height: '10px' }}></div>
        </div>
      )}
    </div>
  );
};

export default BuscarDelivery;
